// Start a run of a workflow now (POST /api/workflows/{id}/runs) and open it.
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { messages } from "../i18n";
import { toast } from "../layout/toast";
import { triggerRun } from "./api";

export function useTriggerRun() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: triggerRun,
    onSuccess: async (run) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["runs"] }),
        queryClient.invalidateQueries({ queryKey: ["workflows", run.workflow_id, "runs"] }),
      ]);
      toast(messages().workloads.run.queued);
      void navigate(`/runs/${run.id}`);
    },
    onError: (err) => toast(err.message, "warn"),
  });
}
